var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "staking-detail" },
    [
      _c("div", { staticClass: "item" }, [
        _c("div", [_vm._v(_vm._s(_vm.$t("stakingAmount")))]),
        _vm._v(" "),
        _c("div", { staticClass: "bold" }, [
          _vm._v(_vm._s(_vm.totalStakingAmount))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "light" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("tradeMining.dividends")))]),
          _vm._v(" " + _vm._s(_vm.expectedDividends + " dSLS") + "\n        ")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item no-border" }, [
        _c("div", [_vm._v(_vm._s(_vm.$t("tradeDividend.unlockAmount")))]),
        _vm._v(" "),
        _c("div", { staticClass: "bold" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.cancellingStake + " dSLS") +
              "\n            "
          ),
          _c("span", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.viteBalanceInfo.cancellingStake,
                expression: "viteBalanceInfo.cancellingStake"
              }
            ],
            staticClass: "down-icon __pointer",
            on: { click: _vm.showCancelStakeDetails }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "operations" }, [
        _c(
          "div",
          {
            staticClass: "btn add __pointer",
            on: { click: _vm.showVxConfirm }
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("tradeMining.add")) +
                "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "btn cancel __pointer",
            on: { click: _vm.showStakingList }
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("tradeMining.withdrawList")) +
                "\n        "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("stakingList", {
        ref: "stakingList",
        attrs: { cancelStake: _vm.cancelStake }
      }),
      _vm._v(" "),
      _c("cancelStakeForMining", { ref: "cancelStakeForMining" }),
      _vm._v(" "),
      _c("cancelling-details", { ref: "cancelStakeDetail" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }